import moment from 'moment'
import React from 'react'
import { Modal, Table } from 'semantic-ui-react'
import { getMyRun } from '../api/async/participants/index'
import { Loader } from '../components/Loader'

class RunStatus extends React.Component {
  state = { loading: true }

  async componentDidMount() {
    getMyRun().then(res => {
      this.setState({ runs: res.data })
      this.setState({ loading: false })
    })
  }

  render() {
    return this.state.loading ? (
      <Loader />
    ) : (
      <React.Fragment>
        <h1>ตรวจสอบสถานะผลวิ่ง</h1>
        <h4>
          (รอตรวจสอบผลวิ่งไม่เกิน 24 ชั่วโมง{' '}
          <u style={{ color: 'red' }}>ยกเว้นวันเสาร์-อาทิตย์</u>)
        </h4>
        <Table unstackable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>วันที่ส่งผล</Table.HeaderCell>
              <Table.HeaderCell>รายการวิ่ง</Table.HeaderCell>
              <Table.HeaderCell>ระยะ</Table.HeaderCell>
              <Table.HeaderCell>เวลา</Table.HeaderCell>
              <Table.HeaderCell>สถานะ</Table.HeaderCell>
              <Table.HeaderCell>หมายเหตุ</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {this.state.runs.map((each, index) => (
              <Table.Row>
                <Table.Cell>
                  {moment(each.created)
                    .locale('th')
                    .format('LLL')}
                </Table.Cell>
                <Table.Cell>{`${each.participant.race_detail.race.title} - ${
                  each.participant.race_detail.distance.name
                }`}</Table.Cell>
                <Table.Cell>
                  {!each.participant.race_detail.race.is_walk
                    ? each.distance
                    : parseInt(each.distance)}
                </Table.Cell>
                <Table.Cell>
                  {!each.participant.race_detail.race.is_walk ? each.time : ''}
                </Table.Cell>
                <Table.Cell>
                  {each.status === 'pending' ? (
                    <span style={{ color: '#f0bb40' }}>รอการตรวจสอบ</span>
                  ) : each.status === 'pending2' ||
                    each.status === 'pending3' ? (
                    <span style={{ color: '#f0bb40' }}>รอการตรวจสอบ</span>
                  ) : each.status === 'approve' ? (
                    <span style={{ color: 'green' }}>อนุมัติ</span>
                  ) : each.status === 'not_approve' ? (
                    <span style={{ color: 'red' }}>ไม่อนุมัติ</span>
                  ) : (
                    <span style={{ color: '#f0bb40' }}>รอการตรวจสอบ</span>
                  )}
                </Table.Cell>
                <Table.Cell>
                  {each.remark}
                  {each.status === 'not_approve' && (
                    <Modal trigger={<a> รูปภาพ</a>}>
                      <Modal.Content>
                        <img
                          src={`https://api.run24hrs.com/media/${each.image}`}
                        />
                      </Modal.Content>
                    </Modal>
                  )}
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </React.Fragment>
    )
  }
}

export default RunStatus



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/RunStatus.js